import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../app/AuthContext";
import { safeHttpUrl } from "../lib/safeUrl";

export function AdminCandidatePage() {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState<{ candidate: Record<string, unknown>; signals: unknown[] } | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!id) return;
    api.admin.candidate(id).then(setData).catch(() => setData(null));
  }, [id]);

  if (!user || (user.role !== "admin" && user.role !== "super_admin")) {
    return <div className="container empty-state">Admin access required.</div>;
  }
  if (!data) return <div className="container empty-state">Loading…</div>;

  const c = data.candidate as Record<string, string | null>;
  const candidateUrl = safeHttpUrl(c.input_url);

  const act = async (fn: () => Promise<unknown>) => {
    setBusy(true);
    try { await fn(); navigate("/admin/candidates?status=review"); }
    finally { setBusy(false); }
  };

  return (
    <div className="container" style={{ paddingBlock: "2rem", maxWidth: 900 }}>
      <h2>Candidate review</h2>
      <div style={{ marginTop: "1rem", color: "var(--fg-muted)" }}>
        <div><strong>{c.suggested_name ?? "—"}</strong></div>
        <div>{candidateUrl ? <a href={candidateUrl} target="_blank" rel="noreferrer">{c.input_url}</a> : c.input_url}</div>
        <div>Status: {c.status} · Created: {c.created_at && new Date(c.created_at).toLocaleString()}</div>
        {c.review_reason && <div style={{ color: "var(--danger)" }}>Reason: {c.review_reason}</div>}
      </div>

      <div style={{ marginTop: "2rem", display: "flex", gap: "0.5rem" }}>
        <button className="primary" disabled={busy} onClick={() => act(() => api.admin.approve(id!))}>Approve</button>
        <button disabled={busy} onClick={() => act(() => api.admin.reject(id!, "manual reject"))}>Reject</button>
        <button disabled={busy} onClick={() => act(() => api.admin.reprocess(id!))}>Reprocess</button>
      </div>

      <h3 style={{ marginTop: "3rem", fontFamily: "var(--font-serif)" }}>Signals</h3>
      <pre style={{ background: "var(--bg-elevated)", padding: "1rem", borderRadius: "var(--radius)", overflow: "auto", fontSize: "0.8rem" }}>
        {JSON.stringify(data.signals, null, 2)}
      </pre>

      <h3 style={{ marginTop: "2rem", fontFamily: "var(--font-serif)" }}>Raw candidate</h3>
      <pre style={{ background: "var(--bg-elevated)", padding: "1rem", borderRadius: "var(--radius)", overflow: "auto", fontSize: "0.8rem" }}>
        {JSON.stringify(c, null, 2)}
      </pre>
    </div>
  );
}
